import React from "react";
import { Button, Checkbox, Dropdown } from "../../../../BP2Components";
import { formatDateToDMY } from "./TableFIlterScripts";
import ColumnsItem from "../TableFiltersColumnsItem";
import "./TableFiltersColumns.less";
import IntlMessages from "../../../../../util/IntlMessages";
import { MODALS } from "./TableFiltersController";

export const listColumns = (
   showModal,
   setCurrentFilter,
   handleFilterEdit,
   openMenuId,
   setOpenMenuId,
   menuNode,
   setActionId,
   handleDuplicate,
   activeTab,
) => {
   const columns = [
      {
         id: activeTab === 1 ? "add" : "",
         label:
            activeTab === 1 ? (
               <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button style={{ width: "32px", height: "32px" }} buttonType="primary">
                     <span className="material-symbols-outlined">add</span>
                  </Button>
               </div>
            ) : null,
         hide: false,
         renderCell: (item: any) => {
            const dropdownMenu = [
               {
                  id: "edit",
                  name: <IntlMessages id="global.edit" />,
                  onClick: () => {
                     setOpenMenuId(null);
                     showModal(MODALS.FILTER_EDITOR);
                     setCurrentFilter(item);
                  },
               },
               {
                  id: "duplicate",
                  name: <IntlMessages id="global.duplicate" />,
                  onClick: handleDuplicate,
               },
               ...(activeTab !== 1
                  ? []
                  : [
                       {
                          id: "createGroup",
                          name: <IntlMessages id="global.create_group" />,
                          onClick: () => {
                             showModal(MODALS.CREATE_GROUP);
                             setActionId(item.id);
                          },
                       },
                    ]),
               {
                  id: "delete",
                  name: <IntlMessages id="global.delete" />,
                  onClick: () => {
                     setActionId(item.id);
                     showModal(MODALS.CONFIRM_DELETE);
                  },
               },
            ];

            return (
               <ColumnsItem
                  active={item.active}
                  style={{ display: "flex", justifyContent: "center" }}
               >
                  <Button buttonType="primary" onClick={() => setOpenMenuId(item.id)}>
                     <IntlMessages id="global.actions" />
                     <Dropdown
                        items={dropdownMenu}
                        isOpen={openMenuId === item.id}
                        setIsOpen={(value) => setOpenMenuId(value ? item.id : null)}
                        customZIndex={1001}
                        checkForModalRoot={false}
                     />
                  </Button>
               </ColumnsItem>
            );
         },
         resize: true,
      },
      {
         id: "active",
         label: "Aktywny",
         hide: false,
         renderCell: (item: any) => (
            <ColumnsItem active={item.active} style={{ display: "flex", justifyContent: "center" }}>
               <Checkbox
                  checked={item.active}
                  onChange={(e) => {
                     handleFilterEdit(item, e.target.checked, "active");
                  }}
               />
            </ColumnsItem>
         ),
         resize: true,
      },
      {
         id: "name",
         label: "Nazwa",
         hide: false,
         renderCell: (item: any) => <ColumnsItem active={item.active}>{item.name}</ColumnsItem>,
         resize: true,
      },
      {
         id: "profileName",
         label: "Filtr",
         hide: activeTab !== 2,
         renderCell: (item: any) => {
            return <ColumnsItem active={item.active}>{item.profileName}</ColumnsItem>;
         },
         resize: true,
      },
      {
         id: "updated",
         label: "Data modyfikacji",
         hide: false,
         renderCell: (item: any) => (
            <ColumnsItem active={item.active}>{formatDateToDMY(item.updated)}</ColumnsItem>
         ),
         resize: true,
      },
      {
         id: "createdBy",
         label: "Autor modyfikacji",
         hide: false,
         renderCell: (item: any) => (
            <ColumnsItem active={item.active}>{item.createdBy}</ColumnsItem>
         ),
         resize: true,
      },
   ];
   return columns;
};
